import React from "react";
import { PhoneOutlined, CompassOutlined, ClockCircleOutlined, UserOutlined, WhatsAppOutlined, NotificationOutlined } from '@ant-design/icons';
import countryList from 'country-list';
import moment from 'moment-timezone';
import { injectIntl } from "react-intl";
import { formatPhoneNumberForDisplay, getCountryCode } from "../../../../util/helpers";
import { cleanText, contactName, referralLabel, safeHttpUrl, whatsappReferral } from "../../../../util/whatsappProfile";
import CountryFlag from "../../../CountryFlag/CountryFlag";
import './GeneralInfoRectangle.less';
import IntlMessages from "../../../../util/IntlMessages";

const GeneralInfoRectangle = ({selectedConversation, intl}) => {
  const t = (id, defaultMessage) => intl.formatMessage({id, defaultMessage});

  const countryCode = getCountryCode(selectedConversation.clientNumber);
  const savedName = contactName(selectedConversation.contactDetails);
  const whatsapp = selectedConversation.whatsappProfile;
  const whatsappName = cleanText(whatsapp?.name);
  const whatsappUsername = cleanText(whatsapp?.username);
  const referral = whatsappReferral(whatsapp);
  const referralUrl = safeHttpUrl(referral?.sourceUrl);

  const getTime = () => {
    const timezones = countryCode ? moment.tz.zonesForCountry(countryCode) : [];
    const now = timezones?.length ? moment.utc().tz(timezones[0]) : moment();
    return now.format('HH:mm');
  };

  return (
    <div className="user-details__main general_info">
      <div className="user-details__box">
        <p className='user-details__title'><IntlMessages id="chats.generalInfo"/></p>
        <div className="user-details__bottom user-details__text">
          {savedName && (
            <p><UserOutlined />{savedName}</p>
          )}
          {(whatsappName || whatsappUsername) && (
            <p title={t('chats.whatsappName', 'WhatsApp profile name')}>
              <WhatsAppOutlined />
              {whatsappName}
              {whatsappUsername ? <span className={whatsappName ? 'general_info__muted' : undefined}>@{whatsappUsername}</span> : null}
            </p>
          )}
          <p className="phone-wrapper">
              <PhoneOutlined type="phone"/>
              {countryCode && (
                  <CountryFlag countryCode={countryCode} />
              )}
              {formatPhoneNumberForDisplay(selectedConversation.clientNumber)}
          </p>
          {countryCode && (
              <p><CompassOutlined />{countryList.getName(countryCode)}</p>
          )}
          <p><ClockCircleOutlined />{getTime()}</p>
          {referral && (
            <p title={t('chats.whatsappReferral', 'Came from a WhatsApp ad')}>
              <NotificationOutlined />
              {referralUrl
                ? <a href={referralUrl} target="_blank" rel="noopener noreferrer nofollow">{referralLabel(referral) || t('chats.whatsappReferral', 'Came from a WhatsApp ad')}</a>
                : (referralLabel(referral) || t('chats.whatsappReferral', 'Came from a WhatsApp ad'))}
            </p>
          )}
        </div>
      </div>
    </div>
  )
};

export default injectIntl(GeneralInfoRectangle);
